// removed by extract-text-webpack-plugin
module.exports = {"dialog":"scroll-dialog__dialog___QbTP3"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/dialog/scroll-dialog.css
// module id = 1175
// module chunks = 0